import { Patient } from '@babylon/consumer-api/types'
import {
  RESET_USER_DETAILS,
  SET_USER_DETAILS,
  SET_USER_ELIGIBILITY,
  SET_USER_EXISTS,
} from './constants'

const setUserProfile = (payload: Partial<Patient>) => {
  const { id, email } = payload

  return {
    type: SET_USER_DETAILS,
    payload: {
      ...payload,
      ...(id && { id: id?.toString() }),
      ...(email && { email: email?.toLowerCase() }),
    },
  }
}

const setUserEligibility = (eligible: boolean) => ({
  type: SET_USER_ELIGIBILITY,
  payload: {
    eligible,
  },
})

const resetUserProfile = () => ({
  type: RESET_USER_DETAILS,
})

const setUserExists = (userExists: boolean) => ({
  type: SET_USER_EXISTS,
  payload: {
    userExists,
  },
})

export { setUserProfile, resetUserProfile, setUserEligibility, setUserExists }
